import promotion from '@/api/promotion'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  main_programs: [],
  sub_programs: [],
  ac_terms: [],
  date_range: [
    moment().format('DD-MM-YYYY'),
    moment()
      .endOf('M')
      .format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
  SET_SUB_PROGRAMS(state, data) {
    state.sub_programs = data
  },
  SET_TERMS(state, data) {
    state.ac_terms = data
  },
  SET_DATE_RANGE(state, date) {
    state.date_range = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_range[0],
        date_to: context.state.date_range[1]
      },
      attrubutes
    )
    return promotion.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return promotion.store(data)
  },

  update(context, data) {
    return promotion.update(data)
  },
  destroy(context, id) {
    return promotion.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await promotion.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async getSubProgram(context, acp_id) {
    context.state.sub_programs = []
    context.state.ac_terms = []
    let response = await promotion.getSubProgram(acp_id)
    context.commit('SET_SUB_PROGRAMS', response)
    return response
  },

  async getTerm(context, acps_id) {
    let response = await promotion.getTerm(acps_id)
    context.commit('SET_TERMS', response)
    return response
  },

  async dataBeforeCreate(context) {
    if (!context.state.main_programs.length > 0) {
      let response = await promotion.getMainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
  }
}
